module.exports = __webpack_public_path__ + "img/aircon_hot_off.20db153d.png";